<template>
  <div class="w3-content" style="max-width:1100px">
    <div class="w3-row w3-padding-34 w3-center" id="about">
      <form action="#" target="_blank">
        <p class="w3-center">
          <!-- <button class="w3-button w3-light-grey w3-section" type="submit">SUBSCRIBE</button> -->
          <router-link :to="{path:'/a/reg'}" class="w3-button w3-light-grey w3-section">SUBSCRIBE MILK</router-link>
        </p>
      </form>
      <div class="w6-col l6 w3-padding-large">
        <h1 class="w3-center">About Doodhvale</h1><br>
        <p class="w3-large">Doodhvale.com is a brand which stands for providing organically produced farm fresh milk which is completely un-touch from human hands from its own farm setup and deliveres at your doorstep every morning. Doodvale.com has its own quality processes and checks to ensures the quality, hygine and hassle free ontime delivery of your orders. </p>
      </div>
    </div>
    <hr>
    <div class="w3-row w3-padding-34" id="menu">
      <div class="w6-col l6 w3-padding-large">
        <h1 class="w3-center">Our Products</h1><br>
        <h4>Fresh Cow Milk</h4>
        <p class="w3-text-grey">70.00 rs. per 1 LITRE</p><br>
        <div class="w3-col l6 w3-padding-large">
          <img src="http://doodhvale.in//dv/doodhvale/backend/web/uploads/lgXr4oKrZc8DoA1xoMduJknO6Phu_iQs.JPG" class="w3-round w3-image" alt="Menu" style="width:100%">
        </div>
        <div style="clear: both;"></div>
        <h4>Pure Cow Ghee</h4>
        <p class="w3-text-grey">850.00 rs. per 1 KG</p>
        <div class="w3-col l6 w3-padding-large">
          <img src="http://doodhvale.in//dv/doodhvale/backend/web/uploads/AY5jUzfRc0nzRo6eyppousaWopsZ7Hij.png" class="w3-round w3-image" alt="Menu" style="width:100%">
        </div>
        <br>
      </div>
    </div>
    <hr>
    <div class="w3-container w3-padding-34" id="contact">
      <h1>Contact</h1><br>
      <p class="w3-text-blue-grey w3-large">You can also contact us by phone 8010342342 or email care@doodhvale.in</p>
      <p class="w3-text-blue-grey w3-large">Click below to subscribe milk</p>
      <form action="#" target="_blank">
        <p class="w3-center">
          <!-- <button class="w3-button w3-light-grey w3-section" type="submit">SUBSCRIBE</button> -->
          <router-link :to="{path:'/a/reg'}" class="w3-button w3-light-grey w3-section">SUBSCRIBE MILK</router-link>
        </p>
      </form>
    </div>
  </div>
</template>
<script>
  // import axios from 'axios'
  export default {
    data () {
    },
    created () {
      var fullUrl = document.URL
      var splitUrl = fullUrl.split('r?')
      sessionStorage.setItem('urlstr', splitUrl[1])
    },
    methods: {
    }
  }
</script>
<style>
body {font-family: "Times New Roman", Georgia, Serif;}
h1, h2, h3, h4, h5, h6 {
  font-family: "Playfair Display";
  letter-spacing: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/R_old.vue